import React from 'react';
import { Link } from 'react-router-dom';
import JsonEditor, { jsonText } from '../JsonEditor';
import { actionText, gapText, statusText, whenText } from '../../drift/findingModel';

const dash = (v) => (v === undefined || v === null || v === '' ? '-' : String(v));

// A finding opened in place: what was expected and observed, which policy decided, what would fix it and its history. Read only: a finding
// is the state of the world, recomputed on every evaluation, so it is not edited. The link opens the device it is about.
export default function FindingView({ finding, account }) {
  const f = finding;
  const raw = f;
  const exception = f.exception ? `${f.exception.reason} (approved by ${f.exception.approvedBy}, until ${f.exception.expires})` : null;
  const detail = f.detail && Object.keys(f.detail).length ? f.detail : null;
  return (
    <div className="finding-view" role="group" aria-label={`${f.subjectName || f.subject} finding`}>
      <dl className="kv">
        <dt>What</dt><dd>{gapText(f.gap)}: {dash(f.subjectName)}</dd>
        <dt>Status</dt><dd>{statusText(f.status)}, {f.severity}</dd>
        <dt>State</dt><dd>{f.state}</dd>
        <dt>Expected</dt><dd className="long">{dash(f.expected)}</dd>
        <dt>Observed</dt><dd className="long">{dash(f.observed)}</dd>
        {f.note && <><dt>Note</dt><dd className="long">{f.note}</dd></>}
        <dt>Decided by</dt><dd className="long">{dash(f.policySource)}{f.policyId ? ` (${f.policyId})` : ''}</dd>
        {f.rule && <><dt>Rule</dt><dd>{f.rule}</dd></>}
        {exception && <><dt>Exception</dt><dd className="long">{exception}</dd></>}
        <dt>Action</dt><dd>{actionText(f)}</dd>
        <dt>First seen</dt><dd>{whenText(f.firstSeenUtc)}</dd>
        <dt>Last seen</dt><dd>{whenText(f.lastSeenUtc)}</dd>
        {f.state === 'resolved' && <><dt>Resolved</dt><dd>{whenText(f.resolvedUtc)}</dd></>}
        <dt>Id</dt><dd className="mono long">{f.id}</dd>
      </dl>
      {Array.isArray(f.detail && f.detail.cves) && f.detail.cves.length > 0 && (
        <div className="field">
          <div className="label">CVEs that count ({f.detail.count}{f.detail.excluded ? `, ${f.detail.excluded} excluded` : ''})</div>
          <table className="mini" aria-label="CVEs">
            <thead><tr><th>CVE</th><th>Score</th><th>Severity</th><th>Match confidence</th></tr></thead>
            <tbody>
              {f.detail.cves.map((c) => (
                <tr key={c.cve}>
                  <td><a href={`https://www.cve.org/CVERecord?id=${encodeURIComponent(c.cve)}`} target="_blank" rel="noopener noreferrer">{c.cve}</a></td>
                  <td>{c.score}</td><td>{String(c.severity || '').toLowerCase()}</td><td>{c.confidence}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {detail && (
        <div className="field">
          <div className="label">Details</div>
          <JsonEditor value={jsonText(detail)} readOnly label="Finding details" />
        </div>
      )}
      <div className="field">
        <div className="label">Raw finding</div>
        <JsonEditor value={jsonText(raw)} readOnly label="Raw finding" maxHeight={520} />
      </div>
      <div className="editor-actions">
        <Link className="btn btn-sm" to={`/v3/devices?account=${encodeURIComponent(account)}&device=${encodeURIComponent(f.device || f.deviceId)}`}>Open {f.device || f.deviceId}</Link>
      </div>
    </div>
  );
}
